export default {
  id: null,
  user_id: null,
  cost_centre_id: null,
  task_id: null,
  task: "",
  custom_number: "",
  destination: "",
  destinationText: null,
  start_place_id: null,
  start_place_text: null,
  end_place_id: null,
  end_place_text: null,
  start_date: null,
  end_date: null,
  time_start: null,
  time_end: null,
  date_time_start: null,
  allowed_transport: [],
  settlement_deadline: "",
  allowed_transport_cost: null,
  advances: [],
  travel_service_order_ids: [],
  project_id: null,
  external_customer_id: null,
  company_id: null,
  estimated_total_cost: null
};
